var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        width: "1000px",
        title: _vm.editData.id ? "修改税率库信息" : "新增税率库信息",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        "append-to-body": "",
        top: "3vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { "margin-top": "-20px" },
          attrs: { model: _vm.form, rules: _vm.rules, "status-icon": "" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.hsCode,
                        "label-width": _vm.formLabelWidth80,
                        prop: "hsCode",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.editData.hsCode ? true : false,
                          oninput: "value=value.replace(/[^\\d]/g,'')",
                          autocomplete: "off",
                        },
                        model: {
                          value: _vm.form.hsCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "hsCode", $$v)
                          },
                          expression: "form.hsCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.baseRate,
                        "label-width": _vm.formLabelWidth120,
                        prop: "baseRate",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 0,
                              precision: 2,
                              step: 0.1,
                              max: 100,
                            },
                            model: {
                              value: _vm.form.baseRate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "baseRate", $$v)
                              },
                              expression: "form.baseRate",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.baseRateWeight,
                        "label-width": _vm.formLabelWidth120,
                        prop: "baseRateWeight",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input", {
                            attrs: {
                              oninput: "value=value.replace(/[^0-9.]/g,'')",
                              autocomplete: "off",
                            },
                            model: {
                              value: _vm.form.baseRateWeight,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "baseRateWeight", $$v)
                              },
                              expression: "form.baseRateWeight",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.originCountry,
                        "label-width": _vm.formLabelWidth80,
                        prop: "originCountry",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "select" },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                filterable: "",
                                placeholder: "请选择原产国",
                              },
                              model: {
                                value: _vm.form.originCountry,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "originCountry", $$v)
                                },
                                expression: "form.originCountry",
                              },
                            },
                            _vm._l(_vm.countryOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  label: item.regionCode + "-" + item.label,
                                  value: item.regionCode,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.baseRateQuantity,
                        "label-width": _vm.formLabelWidth120,
                        prop: "baseRateQuantity",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input", {
                            attrs: {
                              oninput: "value=value.replace(/[^0-9.]/g,'')",
                              autocomplete: "off",
                            },
                            model: {
                              value: _vm.form.baseRateQuantity,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "baseRateQuantity", $$v)
                              },
                              expression: "form.baseRateQuantity",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.baseRateOther,
                        "label-width": _vm.formLabelWidth120,
                        prop: "baseRateOther",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.baseRateOther,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "baseRateOther", $$v)
                          },
                          expression: "form.baseRateOther",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNo,
                        "label-width": _vm.formLabelWidth80,
                        prop: "batchNo",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNo", $$v)
                          },
                          expression: "form.batchNo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.addRate,
                        "label-width": _vm.formLabelWidth120,
                        prop: "addRate",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 0,
                              precision: 2,
                              step: 0.1,
                              max: 100,
                            },
                            model: {
                              value: _vm.form.addRate,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "addRate", $$v)
                              },
                              expression: "form.addRate",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoExempt,
                        "label-width": _vm.formLabelWidth120,
                        prop: "batchNoExempt",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoExempt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoExempt", $$v)
                          },
                          expression: "form.batchNoExempt",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoTwo,
                        "label-width": _vm.formLabelWidth80,
                        prop: "batchNoTwo",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoTwo,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoTwo", $$v)
                          },
                          expression: "form.batchNoTwo",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.addRateTwo,
                        "label-width": _vm.formLabelWidth120,
                        prop: "addRateTwo",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 0,
                              precision: 2,
                              step: 0.1,
                              max: 100,
                            },
                            model: {
                              value: _vm.form.addRateTwo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "addRateTwo", $$v)
                              },
                              expression: "form.addRateTwo",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoTwoExempt,
                        "label-width": _vm.formLabelWidth120,
                        prop: "batchNoTwoExempt",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoTwoExempt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoTwoExempt", $$v)
                          },
                          expression: "form.batchNoTwoExempt",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoThree,
                        "label-width": _vm.formLabelWidth80,
                        prop: "batchNoThree",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoThree,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoThree", $$v)
                          },
                          expression: "form.batchNoThree",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.addRateThree,
                        "label-width": _vm.formLabelWidth120,
                        prop: "addRateThree",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 0,
                              precision: 2,
                              step: 0.1,
                              max: 100,
                            },
                            model: {
                              value: _vm.form.addRateThree,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "addRateThree", $$v)
                              },
                              expression: "form.addRateThree",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoThreeExempt,
                        "label-width": _vm.formLabelWidth120,
                        prop: "batchNoThreeExempt",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoThreeExempt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoThreeExempt", $$v)
                          },
                          expression: "form.batchNoThreeExempt",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoFour,
                        "label-width": _vm.formLabelWidth80,
                        prop: "batchNoFour",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoFour,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoFour", $$v)
                          },
                          expression: "form.batchNoFour",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.addRateFour,
                        "label-width": _vm.formLabelWidth120,
                        prop: "addRateFour",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 0,
                              precision: 2,
                              step: 0.1,
                              max: 100,
                            },
                            model: {
                              value: _vm.form.addRateFour,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "addRateFour", $$v)
                              },
                              expression: "form.addRateFour",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoFourExempt,
                        "label-width": _vm.formLabelWidth120,
                        prop: "batchNoFourExempt",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoFourExempt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoFourExempt", $$v)
                          },
                          expression: "form.batchNoFourExempt",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoFive,
                        "label-width": _vm.formLabelWidth80,
                        prop: "batchNoFive",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoFive,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoFive", $$v)
                          },
                          expression: "form.batchNoFive",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.addRateFive,
                        "label-width": _vm.formLabelWidth120,
                        prop: "addRateFive",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 0,
                              precision: 2,
                              step: 0.1,
                              max: 100,
                            },
                            model: {
                              value: _vm.form.addRateFive,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "addRateFive", $$v)
                              },
                              expression: "form.addRateFive",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoFiveExempt,
                        "label-width": _vm.formLabelWidth120,
                        prop: "batchNoFiveExempt",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoFiveExempt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoFiveExempt", $$v)
                          },
                          expression: "form.batchNoFiveExempt",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoSix,
                        "label-width": _vm.formLabelWidth80,
                        prop: "batchNoSix",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoSix,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoSix", $$v)
                          },
                          expression: "form.batchNoSix",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.addRateSix,
                        "label-width": _vm.formLabelWidth120,
                        prop: "addRateSix",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 0,
                              precision: 2,
                              step: 0.1,
                              max: 100,
                            },
                            model: {
                              value: _vm.form.addRateSix,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "addRateSix", $$v)
                              },
                              expression: "form.addRateSix",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoSixExempt,
                        "label-width": _vm.formLabelWidth120,
                        prop: "batchNoSixExempt",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoSixExempt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoSixExempt", $$v)
                          },
                          expression: "form.batchNoSixExempt",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoSeven,
                        "label-width": _vm.formLabelWidth80,
                        prop: "batchNoSeven",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoSeven,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoSeven", $$v)
                          },
                          expression: "form.batchNoSeven",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.addRateSeven,
                        "label-width": _vm.formLabelWidth120,
                        prop: "addRateSeven",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 0,
                              precision: 2,
                              step: 0.1,
                              max: 100,
                            },
                            model: {
                              value: _vm.form.addRateSeven,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "addRateSeven", $$v)
                              },
                              expression: "form.addRateSeven",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoSevenExempt,
                        "label-width": _vm.formLabelWidth120,
                        prop: "batchNoSevenExempt",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoSevenExempt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoSevenExempt", $$v)
                          },
                          expression: "form.batchNoSevenExempt",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoEight,
                        "label-width": _vm.formLabelWidth80,
                        prop: "batchNoEight",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoEight,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoEight", $$v)
                          },
                          expression: "form.batchNoEight",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.addRateEight,
                        "label-width": _vm.formLabelWidth120,
                        prop: "addRateEight",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "number" },
                        [
                          _c("el-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "controls-position": "right",
                              min: 0,
                              precision: 2,
                              step: 0.1,
                              max: 100,
                            },
                            model: {
                              value: _vm.form.addRateEight,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "addRateEight", $$v)
                              },
                              expression: "form.addRateEight",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.batchNoEightExempt,
                        "label-width": _vm.formLabelWidth120,
                        prop: "batchNoEightExempt",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "off" },
                        model: {
                          value: _vm.form.batchNoEightExempt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "batchNoEightExempt", $$v)
                          },
                          expression: "form.batchNoEightExempt",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.isSteelLicense,
                        "label-width": _vm.formLabelWidth80,
                        prop: "isSteelLicense",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group-spaced",
                          model: {
                            value: _vm.form.isSteelLicense,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isSteelLicense", $$v)
                            },
                            expression: "form.isSteelLicense",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.isAluminumLicense,
                        "label-width": _vm.formLabelWidth80,
                        prop: "isAluminumLicense",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group-spaced",
                          model: {
                            value: _vm.form.isAluminumLicense,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isAluminumLicense", $$v)
                            },
                            expression: "form.isAluminumLicense",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 4 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.isSensitive,
                        "label-width": _vm.formLabelWidth80,
                        prop: "isSensitive",
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "radio-group-spaced",
                          model: {
                            value: _vm.form.isSensitive,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isSensitive", $$v)
                            },
                            expression: "form.isSensitive",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是"),
                          ]),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.certificationItems,
                        "label-width": _vm.formLabelWidth80,
                        prop: "certificationItems",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            multiple: "",
                            filterable: "",
                            "default-first-option": "",
                            placeholder: "请选择认证类型",
                          },
                          model: {
                            value: _vm.form.certificationItems,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "certificationItems", $$v)
                            },
                            expression: "form.certificationItems",
                          },
                        },
                        _vm._l(_vm.itemsOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.desEN,
                        "label-width": _vm.formLabelWidth80,
                        prop: "desEN",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 1,
                          placeholder: "请输入英文描述",
                        },
                        model: {
                          value: _vm.form.desEN,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "desEN", $$v)
                          },
                          expression: "form.desEN",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.formText.desCH,
                        "label-width": _vm.formLabelWidth80,
                        prop: "desCH",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 1,
                          placeholder: "请输入中文描述",
                        },
                        model: {
                          value: _vm.form.desCH,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "desCH", $$v)
                          },
                          expression: "form.desCH",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.formText.remark,
                "label-width": _vm.formLabelWidth80,
                prop: "remark",
              },
            },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 2, placeholder: "请输入备注" },
                model: {
                  value: _vm.form.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c("div", { staticClass: "ok flex_c_c", on: { click: _vm.ok } }, [
            _vm._v("确定" + _vm._s(_vm.editData.id ? "修改" : "新增")),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }